import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/music_lady.png'


const _hoisted_1 = { class: "onboarding welcome" }
const _hoisted_2 = { class: "text-center" }
const _hoisted_3 = { class: "d-flex flex-column align-items-center mt-4" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "text-center mt-5" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "musicLadyImage"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_localized_text, {
        type: "p",
        localizedKey: "app_dall’8 giugno al 4 luglio 2024",
        text: "dall’8 giugno al 4 luglio 2024",
        class: "ff_unbounded"
      }),
      _createVNode(_component_localized_text, {
        type: "h1",
        localizedKey: "app_Sei un vero Bloomer?<br />Dimostralo e vinci i biglietti IDays!",
        text: "Sei un vero Bloomer?<br />Dimostralo e vinci i biglietti IDays!"
      }),
      _createVNode(_component_localized_text, {
        type: "p",
        localizedKey: "app_Gioca al quiz, fai acquisti in Galleria e accumula punti per scalare la classifica!",
        text: "Gioca al quiz, fai acquisti in Galleria e accumula punti per scalare la classifica!",
        class: "text mt-3"
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("button", {
        class: "btn btn-secondary w-100",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/login')))
      }, [
        _createVNode(_component_localized_text, {
          localizedKey: "app_Login",
          text: "Login"
        })
      ]),
      _createElementVNode("button", {
        class: "btn btn-primary w-100 mt-3 mb-4",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/register')))
      }, [
        _createVNode(_component_localized_text, {
          localizedKey: "app_Registrati",
          text: "Registrati"
        })
      ]),
      _createVNode(_component_localized_text, {
        localizedKey: "app_Scopri il regolamento",
        text: "Scopri il regolamento",
        class: "linkButton d-block",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openRulesModal()))
      })
    ]),
    _hoisted_4
  ]))
}